import { render, staticRenderFns } from "./ModalRecoverSolution.vue?vue&type=template&id=5bc4fa33"
import script from "./ModalRecoverSolution.vue?vue&type=script&lang=js"
export * from "./ModalRecoverSolution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports